import React from 'react';
import {
  LayoutDashboard, Bell, MessageSquare, BarChart2, Settings,
  Eye, Mail, LogOut, Search, ChevronDown, RefreshCw, Clock,
  Pause, Play, ArrowRight, ArrowLeft, X, Plus, Check,
  AlertTriangle, Calendar, Key, AlertCircle, Pencil, Trash2, EyeOff,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface IconProps {
  name: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const ICON_MAP: Record<string, LucideIcon> = {
  dashboard:  LayoutDashboard,
  alerts:     Bell,
  comments:   MessageSquare,
  exposure:   BarChart2,
  admin:      Settings,
  eye:        Eye,
  mail:       Mail,
  logout:     LogOut,
  search:     Search,
  chevron:    ChevronDown,
  refresh:    RefreshCw,
  timer:      Clock,
  pause:      Pause,
  play:       Play,
  arrow:      ArrowRight,
  back:       ArrowLeft,
  close:      X,
  plus:       Plus,
  check:      Check,
  warn:       AlertTriangle,
  calendar:   Calendar,
  key:        Key,
  error:      AlertCircle,
  edit:       Pencil,
  trash:      Trash2,
  'eye-off':  EyeOff,
};

const LCIcon: React.FC<IconProps> = ({ name, size = 18, className = '', style }) => {
  const Icon = ICON_MAP[name];
  if (!Icon) return null;
  return <Icon size={size} className={className} style={style} strokeWidth={1.5} />;
};

export default LCIcon;
